/** Dispatched when MSME/carbon workspace metrics may have changed (assessments, documents, profile). */
export const MSME_WORKSPACE_UPDATED_EVENT = 'ci-msme-workspace-updated';

export const notifyMsmeWorkspaceUpdated = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(MSME_WORKSPACE_UPDATED_EVENT));
  }
};
